import api from "./api";

const getClasses = async (page, type) => await api.get('class', {
    params: {
        offset: page * global.PAGE_SIZE, limit: global.PAGE_SIZE, type
    }
})
const getRegisteredClasses = async (page) => await api.get('class/registered', {
    params: {
        offset: page * global.PAGE_SIZE, limit: global.PAGE_SIZE
    }
})
const getClass = async (classId) => await api.get(`class/${classId}`)
const paymentRequest = async (classId, offCode) => await api.get(`class/${classId}/paymentRequest`, {
    params: {
        offCode,isSite:true
    }
})
export default {getClasses,getClass,paymentRequest,getRegisteredClasses}
